module.exports = __webpack_public_path__ + "static/home-hero-image-5c1a9052fa10dfd5d9248ad5bf269c99.jpg";